define('views/pages/account/AccountOrdersView',['underscore', 'jquery', 'app',
        'views/pages/account/AccountView',
        'views/blocks/OrderLineView',
        'InternalLinkView',
        'SelectView',
        'template!blocks/account/orders',
        'template!blocks/account/order-line',
        'views/blocks/AccountOrderView'

    ],
    function (_, $, app,
          AccountView,
          OrderLineView,
          InternalLinkView,
          SelectView,
          ordersTemplate,
          orderLineTemplate,
          AccountOrderView
    )
    {

        //
        // Account Orders View
        // représente les commandes sur la page mon compte
        //

        var view;
        var activeFilters = {}

        return AccountView.extend({

            events: {
                'change .selectpicker':'clickFilter',
                'change #only-reorder':'toggleReorder'
            },

            initialize: function ()
            {
                view = this;
                var customer =  app.getCustomer();
                AccountView.prototype.initialize.apply(view,arguments);

                view.listenTo(app, 'allOrderLoad', view.render);
                //view.render();
                customer.loadAllOrders();

                window.addEventListener('click', view.toogleFilters)
            },
            render: function ()
            {

                var customer = app.getCustomer(),
                    ordering = customer.getOrdering(),
                    orders = customer.getAllOrders();

                var currentYear = new Date().getFullYear(),
                    newestYear = 0,
                    oldestYear = currentYear;
                orders.each(function(order){
                    var orderYear = order.getYear() || currentYear;
                    oldestYear = orderYear > 0 ? Math.min(oldestYear,orderYear) : oldestYear;
                    newestYear = orderYear > 0 ? Math.max(newestYear,orderYear) : newestYear;
                });

                if(newestYear === 0) newestYear = currentYear;

                this.$el.html(ordersTemplate({
                    orders:orders,
                    ordering:ordering,
                    oldestYear:oldestYear,
                    newestYear:newestYear,
                    currentYear:currentYear
                }));
                if (ordering.size() > 0) {
                    ordering.each(function (order) {
                        var orderingView = new AccountOrderView({
                            order: order,
                            tracking: true,
                            trackingdetail: true,
                            target: 'ordering',
                            mode: 'light'

                        });
                        view.$('.ordering').append(orderingView.el);
                        view.attachView(orderingView);
                        orderingView.progessOrderTest();
                    });
                }


                if (orders.size() > 0) {
                    orders.each(function (order) {
                        var orderView = new AccountOrderView({
                            order: order,
                            target: 'orders',
                            trackingdetail:true,
                            productsdetail: true,
                        });
                        view.$('.orders').append(orderView.el);
                        view.attachView(orderView);
                    });
                }
                else
                {
                    view.$('.tab-item.status').remove();
                }
                activeFilters = {
                    delivery: 0,
                    type: 0,
                    year: newestYear,
                    }
                view.filter();
                InternalLinkView.initializeLinksOfView(view);

                view.attachViews(SelectView.initializeSelectsOfView(view));
            },
            clickFilter:function(e){
                var view = this,
                    clikedEl = $(e.currentTarget),
                    val = e.currentTarget.value;

                if (clikedEl.parent().hasClass('order-type__filter')) {
                    activeFilters.type = parseInt(val)
                } else if ((clikedEl.parent().hasClass('order-history__filter'))) {
                    activeFilters.year = parseInt(val)
                } else if ((clikedEl.parent().hasClass('order-delivery__filter'))) {
                    activeFilters.delivery = parseInt(val)
                }
                return this.filter()
            },
            toggleReorder: function(e) {
                activeFilters.onlyReorder = $(e.currentTarget).prop('checked')
                this.filter()
            },
            filter:function(){
                var view = this;

                view.$('.btn-filter').removeClass('active')
                var activeOrders = view.$(
                        '.orders .order-section' +
                        (activeFilters.onlyReorder ? '.reorder_available' : '')+
                        '[data-year="'+activeFilters.year+'"]' +
                        (activeFilters.type ? '[data-type="'+ activeFilters.type +'"]' : '') +
                        (activeFilters.delivery ? '[data-delivery="'+ activeFilters.delivery +'"]' : '')
                    );

                // activeOrders.addClass('active');
                view.$('.orders .order-section, .orders .no-result').hide();

                if(activeOrders.length>0){
                    activeOrders.show();
                }else{
                    view.$('.orders .no-result').show();
                }
            },


            filterType:function(type){
                var view = this, orderOfType = [];

                if (type === 0) {
                    orderOfType = view.$('.orders .order-section[data-type="*"]');
                }
                view.$('.orders .order-section, .orders .no-result').hide();
                view.$('.order-type__filter').removeClass('active').filter('[data-type="'+type +'"]').addClass('active');
                if(orderOfType.length>0){
                    orderOfType.show();
                }else{
                    view.$('.orders .no-result').show();
                }
            }
        });
    });
